import Axios from "services/api/config";
import { getAccessTokenURL } from "services/api/routes/Auth";
import { TOKEN_KEYS } from "utils/constant";
import create from "zustand";

const initialState = {
	user: null,
	// Rehydrate tokens from localStorage on startup. Without this a page
	// refresh reset `token` to null, so App.tsx rendered the auth routes and
	// bounced the user to /login before verifyUser() ever ran.
	token: {
		[TOKEN_KEYS.ACCESS_TOKEN]: localStorage.getItem(TOKEN_KEYS.ACCESS_TOKEN),
		[TOKEN_KEYS.REFRESH_TOKEN]: localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN),
	},
	// Start in the "fetching" state when a session exists, so the very first
	// render shows the loader — not the /login redirect — until verifyUser()
	// resolves.
	fetchingUser: !!localStorage.getItem(TOKEN_KEYS.REFRESH_TOKEN),
};

const userStore = create((set, get) => ({
	...initialState,
	setUser: (data: any) => set({ user: data }),
	setToken: ({ token = null, type = TOKEN_KEYS.ACCESS_TOKEN }: any) => {
		if (!token) {
			localStorage.removeItem(type);
			set((prev: any) => ({ token: { ...prev.token, [type]: token } }));
			return;
		}
		localStorage.setItem(type, token);
		set((prev: any) => ({ token: { ...prev.token, [type]: token } }));
	},
	verifyUser: async (type = TOKEN_KEYS.REFRESH_TOKEN) => {
		const refreshToken = localStorage.getItem(type);
		if (!refreshToken) {
			return localStorage.removeItem(TOKEN_KEYS.REFRESH_TOKEN);
		}
		try {
			set({ fetchingUser: true });
			const { data } = await Axios({
				...getAccessTokenURL,
				data: { refreshToken },
			});
			if (data.data?.token) {
				const { setToken }: any = userStore.getState();
				setToken({ token: data.data.token });
			}
		} catch (error) {
			console.error(error);
		} finally {
			set({ fetchingUser: false });
		}
	},
}));

export default userStore;
